<template>
    <div id="w_drafts">
        <div class="row">
            <div class="col-lg-12 content-title ml-lg-3 mt-1 mb-3">
                <h2 class="content-title">Piszkozatok</h2>
            </div>
        </div>
        <PostFilters :data="data"></PostFilters>
        <Posts :data="data"></Posts>
    </div>
</template>

<script>
    import PostFilters from "../../components/content/PostFilters"
    import Posts from '../../components/content/Posts'
    import { mapGetters } from 'vuex'

    export default{
        name: 'w_posts',
        data() {
            return {
                data: {
                    type: 'draft',
                    path: '/posts/drafts',
                    filters: {
                        q: '',
                        date_from: '',
                        date_to: '',
                        menu_id: '',
                        type: 'draft',
                        user_id: this.userID,
                        post_type: '',
                    }
                }
            }
        },
        components: {
            PostFilters,
            Posts
        },
        computed: {
            ...mapGetters([
                'userID',
            ])
        }
    }
</script>
